<template>
  <div class="flex flex-col flex-1">
    <section>
      <ConsumerPrograms
        :customer="customer"
        :consumer="customer"
        :consumers="consumers"
      />
    </section>
    <div class="px-6 pt-3 space-y-3">
      <ConsumerAppointmentTimeline :customer="customer" @refresh-customer="refresh" />
      <section
        v-show="customer && !customer.certification?.validated_at"
        class="mb-10"
      >
        <CustomerOnboardingCard :customer="customer" />
      </section>
      <div>
        <div class="flex flex-col md:flex-row w-full">
          <div class="flex flex-1 flex-col">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div
                class="flex cursor-pointer w-full"
                @click="navigateToSurveys"
              >
                <div
                  class="bg-white px-3 py-2 shadow rounded-md sm:rounded-lg sm:overflow-hidden min-w-max flex flex-1 flex-row items-center justify-between border-2 border-transparent hover:border-primary/50"
                >
                  <div class="flex flex-row items-center">
                    <icon name="mdi-file-document-edit-outline" color="primary" :size="35" class="mr-2" />
                    <h2 class="text-primary">
                      Préremplir les documents
                    </h2>
                  </div>
                  <p class="text-2xl text-primary">
                    >
                  </p>
                </div>
              </div>
              <div
                class="flex cursor-pointer w-full"
                @click="navigateToSurveys"
              >
                <div
                  class="bg-white px-3 py-2 shadow rounded-md sm:rounded-lg sm:overflow-hidden min-w-max flex flex-1 flex-row items-center justify-between border-2 border-transparent hover:border-primary/50"
                >
                  <div class="flex flex-row items-center">
                    <Microscope class="w-8 h-8 mr-2 text-primary" />
                    <h2 class="text-primary">
                      TROD
                    </h2>
                  </div>
                  <p class="text-2xl text-primary">
                    >
                  </p>
                </div>
              </div>
              <div
                class="flex cursor-pointer w-full"
                @click="navigateToSurveys"
              >
                <div
                  class="bg-white px-3 py-2 shadow rounded-md sm:rounded-lg sm:overflow-hidden min-w-max flex flex-1 flex-row items-center justify-between border-2 border-transparent hover:border-primary/50"
                >
                  <div class="flex flex-row items-center">
                    <icon name="mdi-clipboard-text-outline" color="primary" :size="35" class="mr-2" />
                    <h2 class="text-primary">
                      Voir les questionnaires
                    </h2>
                  </div>
                  <p class="text-2xl text-primary">
                    >
                  </p>
                </div>
              </div>
              <div>
                <CustomerDrugInteractionCard :customer-id="customer.id" />
              </div>
            </div>
            <div
              v-if="partnership"
              class="my-3"
            >
              <div>
                <CustomerMedicineCabinetCard
                  :medicine-cabinet-id="customer.medicine_cabinet_id"
                  :program="partnership"
                  :customer="customer"
                />
              </div>
            </div>
            <div
              v-if="memberships"
              class="my-3"
            >
              <h2>Carte de fidélité</h2>
              <div>
                <CustomerMembershipCard
                  :customer-id="customer.id"
                />
              </div>
            </div>
            <div
              v-else
              class="flex flex-1 justify-center"
            >
              <BaseSpinner />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {computed, watch} from "vue";
import CustomerMembershipCard from '@/customer/components/customer-home/CustomerMembershipCard.vue';
import BaseSpinner from '@/core/components/base/spinner/BaseSpinner.vue';
import CustomerOnboardingCard from '@/customer/components/customer-home/CustomerOnboardingCard.vue';
import CustomerMedicineCabinetCard from '@/customer/components/customer-home/CustomerMedicineCabinetCard.vue';
import ConsumerPrograms from '@/consumer/components/consumer-programs/ConsumerPrograms.vue';
import {storeToRefs} from 'pinia';
import {usePatientStore} from '@/stores/patient.store';
import {Program} from "@/program/interfaces/Program";
import Customer from "@/customer/interfaces/Customer";
import CustomerDrugInteractionCard from "@/customer/components/customer-home/CustomerDrugInteractionCard.vue";
import {ConsumerAppointmentTimeline} from "@/appointment/components/consumer-appointment-timeline";
import Icon from "@/core/components/icon/Icon.vue";
import {Microscope} from "@lucide/vue";
import {useRouter} from "vue-router";

const props = defineProps<{customer: Customer}>();
const {memberships} = storeToRefs(usePatientStore());
const {loadMemberships, refresh} = usePatientStore();
const router = useRouter();

const partnership = computed(() => {
    return props.customer.programs?.find((program: Program) => program.programmable_type === 'feature');
});

const consumers = computed(() => {
    return [
        props.customer,
        ...(props.customer.beneficiaries ?? [])
    ];
});

watch(props.customer, (value) => {
    if (memberships.value === null) {
        loadMemberships(value.id)
            .catch();
    }
}, {immediate: true});

/**
 * Navigate to surveys page.
 */
const navigateToSurveys = () => {
    router.push({name: 'customer.survey.list'});
};
</script>
